import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	height: 44px;
	border-radius: 12px;
	background-color: rgba(50, 50, 50, 0.5);
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	color: #e6e6e6;
	transition: background-color 0.3s ease;
	cursor: pointer;
	user-select: none;

	&.selected {
		background-color: rgba(50, 50, 50, 1);
	}
`;

export { StyledContainer as TabContainer };
